const actionScope = '[Login Status]';

export class LoadLoginStatus {
  static readonly type = `${actionScope} Load Login Status`;
}
